import { render, staticRenderFns } from "./SystemReview.vue?vue&type=template&id=82f53520&"
import script from "./SystemReview.vue?vue&type=script&lang=js&"
export * from "./SystemReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports